import { getRequest, postRequest } from './request'

import { DOMAIN  } from './constant'

export const taskCheckIn = () => {
  return postRequest(`${DOMAIN}/api/task/check_in`, {})
}

export const taskCheckInStatus = () => {
  return getRequest(`${DOMAIN}/api/task/check_in_status`)
}
